import React, { useEffect } from 'react'
import * as QRCode from 'qrcode'

const QRCodeCanvas = ({ value }) => {
  const canvasRef = React.useRef(null)

  useEffect(() => {
    if (!value || !canvasRef.current) return

    QRCode.toCanvas(canvasRef.current, value, {
      margin: 1,
      color: {
        dark: '#000000',
        light: '#ffffff',
      },
    })
  }, [value])

  return (
    <canvas
      ref={canvasRef}
      style={{ width: '100%', height: '100%', objectFit: 'contain' }}
    />
  )
}

export default QRCodeCanvas
